import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
export const PageOverlay = t0 => {
  const $ = _c(5);
  const {
    isShown,
    className
  } = t0;
  const t1 = isShown ? "z-15 block opacity-100" : "-z-1 hidden opacity-0";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = clsx(t1, "fixed inset-0 h-screen w-screen bg-black-alpha-400 duration-150 ease-in-out", className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className={t2} />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};